<template>
  <div class="col-6">
    <div
      v-if="item.is_action && is_predictive_allow.init && is_predictive_allow.permission === 1"
      :class="`dashboard-card dashboard-card--${item.icon}`"
    >
      <div class="dashboard-card__title-row">
        <img class="dashboard-card__img" :src="`/img/dashboard/${item.icon}.svg`" alt="Zorra" />
        <h6 class="dashboard-card__title">{{ $t(item.title) }}</h6>
        <i-button
          class="dashboard-card__button"
          type="primary"
          size="large"
          :to="{ name: item.to, params: { tutorial: locale === 'ru' } }"
        >
          {{ $t(item.button_title) }}
        </i-button>
      </div>
      <p class="dashboard-card__body">
        {{ $t(item.description) }}
      </p>
    </div>
    <div
      v-else-if="item.is_action && !is_predictive_allow.init"
      :class="`dashboard-card dashboard-card--${item.icon}`"
    >
      <div class="dashboard-card__title-row">
        <img class="dashboard-card__img" :src="`/img/dashboard/${item.icon}.svg`" alt="Zorra" />
        <h6 class="dashboard-card__title">{{ $t(item.title2) }}</h6>

        <i-button
          class="dashboard-card__button"
          type="primary"
          size="large"
          :loading="loading"
          @click="action"
        >
          {{ $t(item.button_title2) }}
        </i-button>
      </div>
      <p class="dashboard-card__body">
        {{ $t(item.description) }}
      </p>
    </div>

    <div v-else-if="!item.is_action" :class="`dashboard-card dashboard-card--${item.icon}`">
      <div class="dashboard-card__title-row">
        <img class="dashboard-card__img" :src="`/img/dashboard/${item.icon}.svg`" alt="Zorra" />
        <h6 class="dashboard-card__title">{{ $t(item.title) }}</h6>
        <i-button
          class="dashboard-card__button"
          :to="{ name: item.to, params: { tutorial: locale === 'ru' } }"
          type="primary"
          size="large"
        >
          {{ $t(item.button_title) }}
        </i-button>
      </div>
      <p class="dashboard-card__body">
        {{ $t(item.description) }}
      </p>
    </div>
  </div>
</template>

<script>
  import { ModulesService } from '@core/services/ModulesService';

  export default {
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
    data: () => ({
      locale: '',
      loading: false
    }),
    watch: {
      '$i18n.locale': function (newVal) {
        this.locale = newVal;
      }
    },
    mounted() {
      this.locale = this.$i18n.locale;
    },
    created() {
      this.is_predictive_allow = this.$modules.predictive;
    },
    methods: {
      action() {
        this.loading = true;
        ModulesService.updateStatus(this.$user.id, { module_predictive_is_allowed: true })
          .then((response) => {
            if (response.success) {
              this.$noty.success(this.$t('core.dashboard.noty.connect-autocaller'));
              this.loading = false;
              setTimeout(() => {
                window.location.href = '/predictive';
              }, 1000);
            } else {
              this.$noty.server_error();
            }
          })
          .catch((error) => this.$noty.server_error(error));
      }
    }
  };
</script>

<style lang="scss">
  .dashboard-card-row {
    .col-6 {
      margin-bottom: 30px;
    }
  }

  .dashboard-card {
    padding: 20px;
    height: 100%;
    background-color: #ffffff;
    border: solid 1px $grey-dark;
    border-radius: 4px;

    &__button {
      width: 146x;
    }

    &__title-row {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      height: 65px;
    }

    &__img {
      width: 62px;
    }

    &__title {
      margin: 0 12px;
      font-size: 18px;
      font-weight: bold;
    }

    &__body {
      font-size: 16px;
      margin-bottom: 0;
    }

    &__button {
      margin-left: auto;
    }
  }
</style>
